import { render, staticRenderFns } from "./OnBoardings.vue?vue&type=template&id=b2cafde2&"
import script from "./OnBoardings.vue?vue&type=script&lang=js&"
export * from "./OnBoardings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports